<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- flavorTypes -->

  <mat-form-field>
    <app-easy-select
      formControlName="flavorTypes"
      [label]="TITLE + 'FLAVOR_TYPES' | translate"
      [translatePrefixForSelected]="'PRODUCTS.FLAVOR_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [multiple]="true"
      [hasEmptyOption]="false"
      [options]="flavorType | toSelectOption: 'PRODUCTS.FLAVOR_TYPE.':true"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- basedOnSoy -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="basedOnSoy"
      [label]="TITLE + 'BASED_ON_SOY' | translate"
      (ngModelChange)="onBasedOnSoyChanged($event)"
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- proteinContentIsOver28PercentByWeight -->

  <mat-form-field
    *ngIf="
      getCtrl('proteinContentIsOver28PercentByWeight') &&
      getCtrl('basedOnSoy')?.value === true
    "
  >
    <app-easy-checkbox
      formControlName="proteinContentIsOver28PercentByWeight"
      [label]="TITLE + 'PROTEIN_CONTENT' | translate"
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- containsAtLeast50PercentMilkBasedMaterial -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsAtLeast50PercentMilkBasedMaterial"
      [label]="
        TITLE + 'CONTAINS_AT_LEAST50_PERCENT_MILK_BASED_MATERIAL' | translate
      "
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- containsFruitsOrVegetablesAtLeast50Percent -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsFruitsOrVegetablesAtLeast50Percent"
      [label]="
        TITLE + 'CONTAINS_FRUITS_OR_VEGETABLES_AT_LEAST50_PERCENT' | translate
      "
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- sugar fields -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsAddedSugar"
      [label]="CONTAINS_ADDED_SUGAR | translate"
      (ngModelChange)="onSweetenerOrSugarChangedNonAlcoholic()"
    ></app-easy-checkbox>
  </mat-form-field>

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsAddedSweetener"
      [label]="CONTAINS_ADDED_SWEETENER | translate"
      (ngModelChange)="onSweetenerOrSugarChangedNonAlcoholic()"
    ></app-easy-checkbox>
  </mat-form-field>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-select
        formControlName="sugarContentType"
        [label]="SUGAR_CONTENT_TYPE | translate"
        [translatePrefixForSelected]="'PRODUCTS.SUGAR_CONTENT_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="nonAlcoholicSugarContentType"
      >
      </app-easy-select>
    </mat-form-field>

    <mat-form-field *ngIf="getCtrl('sugarContentInGramsPerHundredMilliliters')">
      <app-easy-input
        formControlName="sugarContentInGramsPerHundredMilliliters"
        [label]="SUGAR_CONTENT_IN_GRAMS_PER_HUNDRED_MILLILITERS | translate"
        [labelInfo]="'PRODUCTS.SUGAR_CONTENT_FIELDS.INFO' | translate"
        type="number"
        step="1"
        min="0"
        max="100"
      >
      </app-easy-input>
    </mat-form-field>
  </div>

  <!-- !sugar fields -->
</fieldset>
